<script> 
import {  MethodsTokenZamaniHesaplama } from "@/state/helpers";
import { notificationMethods,GenericComputed } from "@/state/helpers";  
//import apigeneric from "@/helpers/apigeneric"; 
//import moment from "moment";   
export default {
 // mixins: [ apigeneric],
  name: "app", 
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | `+this.$config.APPLICATION_TITLE : this.$config.APPLICATION_TITLE;
    },
  }, 
  mounted() { 
   if(this.JWToken){
    this.TokenZamaniHesaplama()
   }
  },
  watch: { 
    JWToken(){
      //console.log("GELDİ");
          if(!this.JWToken) return;
          this.TokenZamaniHesaplama();
    },
    /**
     * Clear the alert message on route change
     */
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // clear alert on location change
      this.clearNotification();
    },
  },
  methods: {
    ...MethodsTokenZamaniHesaplama,
    ...GenericComputed,
    Get(){

    },
    clearNotification: notificationMethods.clear,
  },
    computed: {
      ...GenericComputed
    }, 
  created(){ 
  }
};
</script>

<template>
  <div id="app"> 
    <RouterView />
  </div>
</template>
